import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useStore } from "../hooks/useStore";
import { RoutePaths } from "../utils/Items";

const ProtectedRoutes: React.FC<{
  component: any;
  path: string;
  exact?: boolean;
  redirect?: string;
}> = (props) => {
  const { authStore } = useStore();
  const token = authStore.token;
  if (!token) return <Redirect to={RoutePaths.Login} />;

  return (
    <Route path={props.path} exact={props.exact} component={props.component}>
      {props.redirect ? <Redirect to={props.redirect} /> : null}
    </Route>
  );
};
export default ProtectedRoutes;
